module.exports = __webpack_public_path__ + "img/1avatar.e8afece5.png";